"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerStatusPrepaymentHintToJSON = exports.CustomerStatusPrepaymentHintFromJSONTyped = exports.CustomerStatusPrepaymentHintFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function CustomerStatusPrepaymentHintFromJSON(json) {
    return CustomerStatusPrepaymentHintFromJSONTyped(json, false);
}
exports.CustomerStatusPrepaymentHintFromJSON = CustomerStatusPrepaymentHintFromJSON;
function CustomerStatusPrepaymentHintFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'amount': (0, _1.AmountFromJSON)(json['amount']),
        'link': !(0, runtime_1.exists)(json, 'link') ? undefined : json['link'],
    };
}
exports.CustomerStatusPrepaymentHintFromJSONTyped = CustomerStatusPrepaymentHintFromJSONTyped;
function CustomerStatusPrepaymentHintToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'amount': (0, _1.AmountToJSON)(value.amount),
        'link': value.link,
    };
}
exports.CustomerStatusPrepaymentHintToJSON = CustomerStatusPrepaymentHintToJSON;
//# sourceMappingURL=CustomerStatusPrepaymentHint.js.map